module.exports = __webpack_public_path__ + "static/media/1.72790243.jpg";